import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Step, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom/cjs/react-router-dom.js";

import { ROUTES } from "../../constants/routing.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectWizardStepsNav extends PureComponent {
  static propTypes = {
    configId: PropTypes.string.isRequired,
    steps: PropTypes.array.isRequired,
    stepCompleteStates: PropTypes.array.isRequired,
    onStepChange: PropTypes.func,

    stepPosition: PropTypes.number.isRequired,
    copyKey: PropTypes.string.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    stepPosition: 0,
    copyKey: "project_wizard.steps"
  };

  // -- RENDER -- //

  render() {
    const { configId, steps, stepCompleteStates, stepPosition } = this.props;

    return (
      <Step.Group widths={steps.length} size="mini">
        {steps.map((step, index) => {
          const stepCompleted = stepCompleteStates[index] === step.id;

          const linkDetails = stepCompleted
            ? {
                as: Link,
                to: `${ROUTES.PROJECT_WIZARD}/${configId}/${step.id}`
              }
            : {};

          return (
            <Step
              key={`step-nav-${step.id}`}
              active={stepPosition === index}
              completed={stepCompleted}
              {...linkDetails}
            >
              <Icon name={step.icon} />
              <Step.Content>
                <Step.Title>{step.name}</Step.Title>
              </Step.Content>
            </Step>
          );
        })}
      </Step.Group>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectWizardStepsNav);
